import { MESSAGE_MAX_LENGTH, SECTIONS } from '../constants'

export const isBodyTooLong = body => body.length > MESSAGE_MAX_LENGTH

// The rule for leaving a step: Audience needs a name, Message needs a message
// that fits. Review has nothing to fill in.
export const isStepValid = (campaign, index) => {
  if (index === 0) return Boolean(campaign.name.trim())
  if (index === 1) {
    return Boolean(campaign.body.trim()) && !isBodyTooLong(campaign.body)
  }
  return true
}

export const firstInvalidStep = campaign =>
  SECTIONS.findIndex((_section, index) => !isStepValid(campaign, index))
